import { path, pathOr } from 'ramda';

export const getOpened = path(['confirmModal', 'opened']);
export const getTitle = path(['confirmModal', 'settings', 'title']);
export const getMessage = path(['confirmModal', 'settings', 'message']);
export const getType = path(['confirmModal', 'settings', 'type']);
export const getConfirmButtonText = path(['confirmModal', 'settings', 'confirmButtonText']);
export const getNegativeButtonText = path(['confirmModal', 'settings', 'negativeButtonText']);
export const getShowConfirmButton = pathOr(true, ['confirmModal', 'settings', 'showConfirmButton']);
export const getShowNegativeButton = pathOr(true, ['confirmModal', 'settings', 'showNegativeButton']);
export const getClassName = path(['confirmModal', 'settings', 'className']);
